/** Figma 75644:10993 / 75911:4490 / 75916:7557 — org chart + table input panel */
export const PLAN_INPUT_PANEL_WIDTH = '283px';
export const PLAN_PROPERTY_CARD_WIDTH = '350px';
export const PLAN_INPUT_PANEL_PADDING = '20px';
export const PLAN_INPUT_PANEL_GAP = '15px';
export const PLAN_INPUT_ACCENT = '#3BA7FA';
export const PLAN_INPUT_SELECTED_BORDER = '#C4B5FD';
export const PLAN_PROPERTY_CARD_SHADOW = '0px 0px 12px rgba(0, 0, 0, 0.1)';
export const DRIVER_PANEL_VIEW_TOGGLE_WIDTH = '138px';
export const DRIVER_PANEL_ACTION_COL_WIDTH = '119px';
export const PLAN_DRIVER_CARD_PADDING = '12px';
export const PLAN_DRIVER_CARD_GAP = '15px';
export const PLAN_DRIVER_NESTED_GAP = '16px';
export const PLAN_DRIVER_CELL_BORDER = '#E8E9EB';
export const PLAN_DRIVER_MID_GREY = '#BEBEBE';
export const PLAN_DRIVER_TABLE_ROW_HEIGHT = '40px';
export const PLAN_DRIVER_TABLE_HEADER_BG = '#F5F0FF';
export const PLAN_DRIVER_TABLE_HEADER_BORDER = '#C4B5FD';
export const PLAN_DRIVER_TABLE_TEXT = '#121826';
export const PLAN_DRIVER_TABLE_PLACEHOLDER = '#708090';
export const PLAN_DRIVER_TABLE_CELL_PADDING_X = '20px';
export const PLAN_DRIVER_TABLE_NAME_PADDING = '12px';
